import create from 'zustand';

type CustomerInfo = {
    email: string;
    phoneMobile: string | number;
    firstName: string;
    lastName: string;
    address1: string;
    city: string;
    postalCode: string;
};

type InStore = {
    setCustomerInfo: (payload: CustomerInfo) => void;
} & CustomerInfo;

export const useInStoreState = create<InStore>((set) => ({
    email: '',
    phoneMobile: '',
    firstName: '',
    lastName: '',
    address1: '',
    city: '',
    postalCode: '',
    setCustomerInfo: (data) => {
        set({ ...data });
    },
}));
